export enum ItemCategories {
  Stock = 'Stock',
  Service = 'Service',
  Alteration = 'Alteration',
  Fee = 'Fee',
  Deposit = 'Deposit',
  DepositRefund = 'DepositRefund',
  Tare = 'Tare',
  ItemCollection = 'ItemCollection',
  Warranty = 'Warranty',
  Ingredients = 'Ingredients',
  Messages = 'Messages',
}
